import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject } from 'vue';
import useCookies from '@/helpers/useCookies'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'CookieConsent',
  setup(__props) {

const gtag = inject<any>('gtag')
const { showBanner, okClicked } = useCookies(gtag)
const store = useStore()

const okBannerClicked = function(){
    return okClicked()
}

const nopeBannerClicked = function(){
    store.commit('nocookies')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["banner-container", {'show': _unref(showBanner)}])
      }, [
        _createElementVNode("p", null, [
          _createTextVNode("Pouvons-nous placer des 🍪 sur votre navigateur ? "),
          _createVNode(_component_router_link, { to: "/cookies" }, {
            default: _withCtx(() => [
              _createTextVNode("Voir notre politique sur les Cookies")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("button", {
            class: "ui button",
            onClick: okBannerClicked
          }, "Accepter"),
          _createTextVNode("   "),
          _createElementVNode("button", {
            class: "ui button",
            onClick: nopeBannerClicked
          }, "Refuser")
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})